(() => {
  'use strict';
  const instances = new Map();
  function init(section) {
    if (instances.has(section)) return;
    const deck = section.querySelector('.mg-shp-deck');
    const slides = [...section.querySelectorAll('[data-mg-social-slide]')];
    const picks = [...section.querySelectorAll('[data-mg-social-pick]')];
    const rail = section.querySelector('.mg-shp-nav');
    const live = section.querySelector('[data-mg-social-announcement]');
    if (!slides.length) { section.remove(); return; }
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const mobile = matchMedia('(max-width: 680px)');
    const motion = new Set();
    let inView = false;
    function clearMotion() {
      motion.forEach(animation => animation.cancel());
      motion.clear();
    }
    function animateElement(element, keyframes, options) {
      if (!element?.animate) return;
      const animation = element.animate(keyframes, options);
      motion.add(animation);
      animation.finished.then(() => motion.delete(animation), () => motion.delete(animation));
    }
    function revealSlide() {
      clearMotion();
      if (!mobile.matches || reduced.matches || !inView || document.hidden) return;
      const slide = slides[index];
      const easing = 'cubic-bezier(.22,1,.36,1)';
      // The heading loops independently in CSS, including during slide interaction.
      animateElement(slide.querySelector('.mg-shp-backdrop-name'), [
        { transform: 'translateX(8px) scaleY(1.55)', opacity: .48 },
        { transform: 'translateX(0) scaleY(1.55)', opacity: .68 }
      ], { duration: 1250, easing });

      animateElement(slide.querySelector('.mg-shp-photo'), [
        { transform: 'translateY(9px) scale(.975)', opacity: .82 },
        { transform: 'translateY(-2px) scale(1)', opacity: 1, offset: .45 },
        { transform: 'translateY(0) scale(1)', opacity: 1 }
      ], { duration: 1050, easing });
      animateElement(slide.querySelector('.mg-shp-name'), [
        { transform: 'translateX(7px)', opacity: .55 },
        { transform: 'translateX(0)', opacity: 1 }
      ], { duration: 520, easing });
      slide.querySelectorAll('.mg-shp-specs>div').forEach((item, i) => {
        animateElement(item, [
          { transform: 'translateY(6px)', opacity: .65 },
          { transform: 'translateY(0)', opacity: 1 }
        ], { duration: 450, delay: 65 + i * 45, easing, fill: 'backwards' });
      });
    }
    function updateMotion() {
      const enabled = inView && mobile.matches && !reduced.matches && !document.hidden;
      section.classList.toggle('is-mobile-motion-visible', enabled);
      if (enabled) revealSlide();
      else clearMotion();
    }
    const events = new AbortController();
    const on = (el, type, handler, opts = {}) => el.addEventListener(type, handler, { ...opts, signal: events.signal });
    let index = 0, frame = 0, settleTimer = 0, pointer = null, suppressClickUntil = 0, requested = null;
    const width = () => deck.clientWidth;
    const wrap = n => (n + slides.length) % slides.length;
    function stop() {
      cancelAnimationFrame(frame); frame = 0; requested = null;
      deck.style.scrollSnapType = '';
    }
    function sync(next, announce = false, animate = true) {
      const changed = index !== wrap(next);
      index = wrap(next);
      section.querySelector('.mg-shp-prev').disabled = index === 0;
      section.querySelector('.mg-shp-next').disabled = index === slides.length - 1;
      picks.forEach((p, i) => p.setAttribute('aria-pressed', String(i === index)));
      slides.forEach((s, i) => { s.inert = i !== index; s.setAttribute('aria-hidden', String(i !== index)); });
      if (announce) live.textContent = `PC Gaming ${slides[index].dataset.mgSocialName}`;
      const active = picks[index];
      if (active && rail.scrollWidth > rail.clientWidth) {
        const left = active.offsetLeft - rail.offsetLeft - (rail.clientWidth - active.offsetWidth) / 2;
        rail.scrollTo({ left, behavior: reduced.matches ? 'auto' : 'smooth' });
      }
      if (changed && animate) revealSlide();
      for (const n of [index, wrap(index + 1), wrap(index - 1)]) {
        slides[n].querySelectorAll('img').forEach(img => { img.loading = 'eager'; });
      }
    }
    function show(next, announce = true) {
      const target = Math.max(0, Math.min(slides.length - 1, next)), from = deck.scrollLeft, to = target * width();
      stop(); clearTimeout(settleTimer);
      clearMotion();
      sync(target, announce, false);
      if (reduced.matches || Math.abs(to - from) < 1) { deck.scrollLeft = to; return; }
      requested = target;
      deck.style.scrollSnapType = 'none';
      const started = performance.now();
      const duration = Math.min(850, 580 + Math.abs(to - from) / width() * 65);
      const tick = now => {
        const t = Math.min(1, (now - started) / duration);
        deck.scrollLeft = from + (to - from) * (1 - Math.pow(1 - t, 5));
        if (t < 1) frame = requestAnimationFrame(tick);
        else { frame = 0; requested = null; deck.style.scrollSnapType = ''; revealSlide(); }
      };
      frame = requestAnimationFrame(tick);
    }
    picks.forEach((p, i) => on(p, 'click', () => show(i)));
    on(section.querySelector('.mg-shp-prev'), 'click', () => show(index - 1));
    on(section.querySelector('.mg-shp-next'), 'click', () => show(index + 1));
    on(section, 'keydown', e => {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') {
        e.preventDefault(); show(index + (e.key === 'ArrowRight' ? 1 : -1));
      }
    });
    on(deck, 'scroll', () => {
      if (frame || pointer) return;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(() => sync(Math.round(deck.scrollLeft / width()), true), 110);
    }, { passive: true });
    on(deck, 'pointerdown', e => {
      clearMotion(); stop();
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      pointer = { id: e.pointerId, x: e.clientX, y: e.clientY, start: deck.scrollLeft, lastX: e.clientX, lastTime: e.timeStamp, speed: 0, dragged: false };
    });
    on(deck, 'pointermove', e => {
      if (!pointer || pointer.id !== e.pointerId) return;
      const dx = e.clientX - pointer.x, dy = e.clientY - pointer.y;
      if (!pointer.dragged && Math.abs(dx) > 7 && Math.abs(dx) > Math.abs(dy)) {
        pointer.dragged = true; deck.setPointerCapture(e.pointerId);
        deck.classList.add('is-dragging'); deck.style.scrollSnapType = 'none';
      }
      if (!pointer.dragged) return;
      e.preventDefault();
      const dt = e.timeStamp - pointer.lastTime;
      if (dt > 0) pointer.speed = (e.clientX - pointer.lastX) / dt;
      pointer.lastX = e.clientX; pointer.lastTime = e.timeStamp;
      deck.scrollLeft = pointer.start - dx;
    });
    function release(e) {
      if (!pointer || pointer.id !== e.pointerId) return;
      const p = pointer; pointer = null; deck.classList.remove('is-dragging');
      if (deck.hasPointerCapture(e.pointerId)) deck.releasePointerCapture(e.pointerId);
      if (!p.dragged) return;
      suppressClickUntil = performance.now() + 350;
      const momentum = Math.max(-width() * .25, Math.min(width() * .25, p.speed * 110));
      const projected = deck.scrollLeft - momentum;
      const next = Math.max(0, Math.min(slides.length - 1, Math.round(projected / width())));
      show(next);
    }
    on(deck, 'pointerup', release); on(deck, 'pointercancel', release);
    on(deck, 'pointerleave', e => { if (pointer && !pointer.dragged) pointer = null; });
    on(deck, 'dragstart', e => e.preventDefault());
    on(deck, 'click', e => { if (performance.now() < suppressClickUntil) { e.preventDefault(); e.stopImmediatePropagation(); } }, { capture: true });
    on(deck, 'wheel', stop, { passive: true });
    const resize = new ResizeObserver(() => {
      stop(); deck.style.scrollSnapType = 'none'; deck.scrollLeft = index * width(); deck.style.scrollSnapType = '';
    });
    resize.observe(deck);
    on(reduced, 'change', () => {
      if (requested !== null) { const target = requested; stop(); show(target, false); }
      updateMotion();
    });
    on(mobile, 'change', updateMotion);
    on(document, 'visibilitychange', updateMotion);
    const visibility = new IntersectionObserver(entries => {
      const entry = entries[entries.length - 1];
      const next = entry.isIntersecting && entry.intersectionRatio >= .2;
      if (next === inView) return;
      inView = next; updateMotion();
    }, { threshold: [0, .2] });
    visibility.observe(section);
    if (slides.length === 1) section.querySelectorAll('.mg-shp-arrow,.mg-shp-nav').forEach(e => e.hidden = true);
    sync(0);
    instances.set(section, () => { stop(); clearTimeout(settleTimer); resize.disconnect(); visibility.disconnect(); clearMotion(); events.abort(); });
  }
  let observer;
  function mount() {
    document.querySelectorAll('.mg-social-picks-v2[data-mg-social-picks]').forEach(init);
    const root = document.querySelector('[data-mg-react-home]');
    const template = document.querySelector('template[id^="MgSocialHotPicksTemplate-"]');
    const band = root?.querySelector('.trust-band');
    if (!root || !template || !band) return false;
    if (!root.querySelector('.mg-social-picks-v2')) {
      root.querySelector('[data-mg-social-picks]')?.remove();
      const section = template.content.firstElementChild.cloneNode(true);
      band.before(section); init(section); band.classList.add('mg-shp-installed');
    }
    return true;
  }
  function start() {
    observer?.disconnect();
    if (mount()) return;
    const root = document.querySelector('[data-mg-react-home]');
    if (!root) return;
    observer = new MutationObserver(() => { if (mount()) observer.disconnect(); });
    observer.observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('shopify:section:unload', e => {
    for (const [section, destroy] of instances) if (e.target.contains(section)) { destroy(); instances.delete(section); }
  });
})();
